/**
 * Catalogue scroll math, without the DOM.
 *
 * The strip and the spy both need "which section owns this scroll position"
 * and they used to recompute it inline. Two bugs lived in that loop: a
 * short last section never crossed the spy line, so tapping MD Products
 * snapped back to Cake; and `offsetTop` under `content-visibility` was a
 * guessed height, so a chip tap landed in the wrong place.
 */

export function sectionTop(box: HTMLElement, el: HTMLElement): number {
  return el.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop
}

/**
 * The last section whose top is at or above the spy line, or the last
 * section entirely once the customer is at the foot of the list.
 */
export function spyCategory(tops: readonly { id: string; top: number }[], line: number, atEnd: boolean): string | null {
  if (tops.length === 0) return null
  if (atEnd) return tops[tops.length - 1]!.id
  let current: string | null = null
  for (const { id, top } of tops) {
    if (top <= line) current = id
  }
  return current
}

/**
 * A first-visit placeholder for `.menu-section`.
 *
 * `contain-intrinsic-size: auto 40rem` was one short coffee row. Coffee has
 * seventeen drinks. A jump over those guessed heights undershot, then the
 * real tiles appeared and the list jumped under the thumb. A row is four
 * tiles of ~14.7rem: a 3:4 photograph, two lines of name and the price
 * band, plus the gap.
 */
export function sectionPlaceholderRem(productCount: number, columns = 4): number {
  const rows = Math.max(1, Math.ceil(productCount / columns))
  return 8 + rows * 32
}
